import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FireDispatchReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/fire-dispatch.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FireDispatchReducer, defaultState, asyncActions);
};

type IFireDispatchContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FireDispatchContext = createContext<Partial<IFireDispatchContext>>({
  state: defaultState,
}) as React.Context<IFireDispatchContext>;

const FireDispatchProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FireDispatchContext.Provider value={{ ...reducer }}>
      {children}
    </FireDispatchContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFireDispatchContext = () => useContext(FireDispatchContext);

export type IUseFireDispatchContext = ReturnType<typeof useFireDispatchContext>;

export { FireDispatchContext, FireDispatchProvider };
